// services/getStaticPageContent.js
import { API_BASE_URL } from '../config';

export async function getStaticPageContent(pageKey, lang = "fr") {
  const response = await fetch(
    `${API_BASE_URL}static_page/${pageKey}?lang=${lang === "uk" ? "en" : lang}`
  );

  if (!response.ok) {
    throw new Error("Page not found");
  }

  const data = await response.json();
  return data.data; // Directly return the data object
}